import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as BackArrow } from '../../../assets/images/backarrow.svg';
import { removeCurrentOrg, setFetchedOrgStatus } from '../../../redux/actions/organizationActions';

import styles from './BackButton.module.scss';

const BackButton = ({ onBack, isArrowButton = false }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const goOneStepBack = () => {
    navigate(-1);
    dispatch(removeCurrentOrg());
    dispatch(setFetchedOrgStatus());
  };
  return isArrowButton ? (
    <div className={styles.arrowContainer} onClick={onBack ?? goOneStepBack} role="presentation">
      <LeftArrow className={styles.leftArrow} />
    </div>
  ) : (
    <div className={styles.container} onClick={onBack ?? goOneStepBack} role="presentation">
      <BackArrow />
      <p className={styles.text}>{t('back')}</p>
    </div>
  );
};

export default BackButton;
